import axios from "axios";
import { Base_URL } from "../url";

export const fetchProjects = async () => {
  try {
    const response = await axios.get(
      `${Base_URL}/ProjectMaster/GetAllProjects`,
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching projects!";
  }
};

export const fetchProjectsByOrg = async (orgId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/ProjectMaster/GetProjectsByOrg/${orgId}`,
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching projects by organization!";
  }
};

export const fetchProjectDetails = async (projectId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/ProjectMaster/GetProjectById/${projectId}`,
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching project details!";
  }
};

export const updateProject = async (projectId, projectData) => {
  try {
    const response = await axios.put(
      `${Base_URL}/ProjectMaster/UpdateProject/${projectId}`,
      projectData,
    );
    console.log("Update response:", response.data);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error updating project!";
  }
};

export const downloadProjectsExcel = async () => {
  try {
    const response = await axios.post(
      `${Base_URL}/ProjectMaster/ExportProjectsToExcel`,
      null,
      {
        responseType: "blob",
        headers: {
          "Content-Type": "application/json",
          Accept:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
      },
    );
    return response;
  } catch (error) {
    throw error.response?.data || "Error downloading projects data!";
  }
};

export const fetchProjectsByTeamMember = async (orgId, memberId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/ProjectMaster/GetProjectsByTeamMember/${orgId}/${memberId}`,
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching projects by team member!";
  }
};

export const fetchProjectLogs = async (projectId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/ProjectMaster/GetProjectLogs/${projectId}`,
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching project logs!";
  }
};

export const fetchProjectRemarks = async (projectId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/ProjectMaster/GetProjectRemarks/${projectId}`,
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching project remarks!";
  }
};

export const addProjectRemark = async (data) => {
  try {
    const response = await axios.post(
      `${Base_URL}/ProjectMaster/AddProjectRemark`,
      {
        projectId: data.projectId,
        remarks: data.remarks,
        userId: data.userId,
        createdBy: data.createdBy, // Send contact GUID as createdBy
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error adding project remark:", error);
    throw error;
  }
};

// New API for updating project remark
export const updateProjectRemark = async (projectId, updateData) => {
  try {
    const response = await axios.put(
      `${Base_URL}/ProjectMaster/UpdateProjectRemark/${projectId}`,
      updateData,
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error updating project remark!";
  }
};

// ================= NEW DAPPER APIs =================

// // 1️⃣ Get ALL projects (from view)
// export const fetchProjectBase = async () => {
//   try {
//     const response = await axios.get(
//       `${Base_URL}/Project/project-base`
//     );
//     return response.data;
//   } catch (error) {
//     throw error.response?.data || "Error fetching project base!";
//   }
// };

// 2️⃣ Get projects by OrgId
export const fetchProjectBaseByOrg = async (orgId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/Project/project-base/${orgId}`,
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching project base by org!";
  }
};

// 3️⃣ 🔥 Get projects by OrgId + MemberId (IMPORTANT)
export const fetchProjectBaseByOrgAndMember = async (orgId, memberId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/Project/project-base/${orgId}/${memberId}`,
    );
    return response.data;
  } catch (error) {
    throw (
      error.response?.data || "Error fetching project base by org & member!"
    );
  }
};
